<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: undefined,
  },
  optionTrue: {
    type: String,
    required: true,
  },
  optionFalse: {
    type: String,
    required: true,
  },
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
  textFont: {
    type: String,
    default: 'null',
  },
  fancy: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:modelValue']);

const checkedIcon = props.fancy ? 'circle' : '';
const uncheckedIcon = props.fancy ? 'radio_button_unchecked' : '';
const indeterminateIcon = props.fancy ? 'radio_button_unchecked' : '';

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emits('update:modelValue', val);
  },
});
</script>

<template>
  <div class="input">
    <p v-if="$slots.default" class="custom-font">
      <slot></slot>
    </p>

    <div class="input-choose">
      <div class="input" :class="{ 'label-right': fancy }">
        <p class="label">{{ optionTrue }}</p>
        <q-checkbox
          v-model="model"
          borderless
          class="core-default-input-form checkbox rsvp-guest-checkbox-true-false"
          :true-value="true"
          :false-value="false"
          :checked-icon="checkedIcon"
          :unchecked-icon="uncheckedIcon"
          :indeterminate-icon="indeterminateIcon"
        />
      </div>
      <div class="input" :class="{ 'label-right': fancy }">
        <p class="label">{{ optionFalse }}</p>
        <q-checkbox
          v-model="model"
          borderless
          class="core-default-input-form checkbox rsvp-guest-checkbox-true-false"
          :true-value="false"
          :false-value="true"
          :checked-icon="checkedIcon"
          :unchecked-icon="uncheckedIcon"
          :indeterminate-icon="indeterminateIcon"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
/* stylelint-disable selector-class-pattern */
.rsvp-guest-checkbox-true-false > .q-checkbox__inner,
.rsvp-guest-checkbox-true-false > .q-checkbox__inner--truthy {
  color: v-bind(mainColor) !important;
}
/* stylelint-enable selector-class-pattern */
</style>

<style lang="scss" scoped>
.checkbox {
  border: none;
  align-items: center;
  justify-content: center;
  background-color: v-bind(backgroundColor);
  width: auto;
  margin: auto;
}

.input {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .custom-font {
    font-family: v-bind(textFont), 'Petit Formal Script', serif;
    font-style: normal;
    font-weight: 400;
  }
}

.input-choose {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding-top: 5px;
  width: 100%;

  .input {
    gap: 0;

    .label {
      text-align: center;
      font-family: v-bind(textFont), 'MADE Mirage', serif;
      font-size: 22px;
      margin: 0;
      font-weight: 300;
    }
  }
}

.label-right {
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;

  .checkbox {
    padding: 10px;
  }
}
</style>
